import React from "react";

const Terms_And_Conditions = () => {
  return (
    <>
     <section className="privacy-policy-sec sec">
  <div className="container">
    <div className="row">
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <div className="privacy-policy-txt-main">
          <div className="privacy-policy-txt">
            <h2 className="text-center">Terms and Conditions</h2>
            <p>
              These Terms and Conditions (“Terms”) govern your use of the website and services provided by <strong>The Design Showroom Ltd</strong>, registered in England and Wales. By accessing our website <a href="www.thedesignshowroom.com">www.thedesignshowroom.com</a>, visiting our showroom, or engaging with our products and services, you agree to comply with these Terms.</p>
          </div>
          <div className="privacy-policy-txt">
            <h2>Company Information</h2>
            <p>
              The Design Showroom Ltd is part of the Luxe Family portfolio and operates as a high-end retailer of luxury interior and exterior products, showcasing curated partner brands. For any enquiries, please contact us at <a href="mailto:sales@thedesignshowroom.com">sales@thedesignshowroom.com</a>.
            </p>
            <h2>Products and Services</h2>
            <p>All products displayed in our showroom or online are subject to availability. While we strive for accuracy in descriptions, images, and specifications, variations in colour, texture, or finish may occur. Bespoke and customised items are made to order and are therefore non-refundable.</p>
            <h2>Pricing and Payment</h2>
            <p>Prices are provided upon request or quotation and exclude delivery, installation, and applicable VAT unless otherwise stated. Full payment must be made as agreed before delivery or commencement of work.</p>
            <h2>Delivery and Installation</h2>
            <p>Estimated delivery times will be confirmed at the time of order. Delays caused by third parties or unforeseen circumstances are outside our control. Installation services, where offered, will be carried out by approved professionals.</p>
            <h2>Returns and Cancellations</h2>
            <p>Non-customised products may be returned within 14 days in their original condition, subject to approval. Bespoke or customised products cannot be returned or cancelled once production has begun.</p>
            <h2>Intellectual Property</h2>
            <p>All content, images, designs, and materials on our website and showroom displays remain the property of The Design Showroom Ltd or our brand partners and may not be copied or reproduced without written consent.</p>
            <h2>Liability</h2>
            <p>We are not liable for indirect, incidental, or consequential damages arising from use of our products or services, except where required by UK law.</p>
            <h2>Governing Law</h2>
            <p>These Terms are governed by and construed in accordance with the laws of England and Wales.</p>
          </div>
        </div>
      </div>
    </div>
  </div></section>

    </>
  );
};

export default Terms_And_Conditions;
